// Centralized server base URL configuration.
// The base URL is stored in localStorage so it can be changed at runtime
// (see the "Server URL" option in Operations) without editing code.

const DEFAULT_BASE_URL = 'http://localhost:4125';
const STORAGE_KEY = 'injee-base-url';

const normalize = (url) => (url || '').trim().replace(/\/+$/, '');

export const getBaseUrl = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      return normalize(saved);
    }
  } catch {
    // ignore
  }
  return DEFAULT_BASE_URL;
};

export const setBaseUrl = (url) => {
  const normalized = normalize(url);
  try {
    if (normalized) {
      localStorage.setItem(STORAGE_KEY, normalized);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // ignore
  }
  return normalized || DEFAULT_BASE_URL;
};

export const getDefaultBaseUrl = () => DEFAULT_BASE_URL;
